import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

interface StyledProps {
  zIndex?: number;
  fixed: boolean;
}

export const FloatingContainer = styled.div.attrs<any, StyledProps>((): any => ({}))`
  position: fixed;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  bottom: 32px;
  right: 32px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 350px;
    border-radius: 28px;

    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;
    ${({ fixed }) => {
      if (fixed) {
        return `
          width: 100%;
          align-items: center;
          justify-content: center;
          background-color: ${ColorPalette.HEX.White};
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
        `;
      }
    }}
  }
`;

export const ConfirmButton = styled(Button)`
  height: 56px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 350px;
  }
`;
